import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { useSocketIOContext } from ".";
import { ReadyState } from "react-use-websocket";
import {useGameStore} from "../../store";

type TBlockedReason = 403 | 404 | 418 | null | undefined;

export const ConnectionLostIndicator = () => {
  const { connected } = useSocketIOContext();
  const blockedReason = useGameStore((state)=> state.blockedReason ) as TBlockedReason;
  const [disconnected, setDisconnected] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (!connected) {
      timeout = setTimeout(() => {
        setDisconnected(true);
      }, 2000);
    } else {
      setDisconnected(false);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [connected]);

  return createPortal(
    <DisconnectedOverlay $active={disconnected && !blockedReason}>
      <DisconnectedLabel>
        Reconnecting
      </DisconnectedLabel>
    </DisconnectedOverlay>,
    document.body
  );
};

const DisconnectedLabel = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
`;

const DisconnectedOverlay = styled.div<{
  $active: boolean;
}>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background-color: #00000088;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  opacity: ${({ $active }) => $active ? 1.0 : 0.0};
  pointer-events: ${({ $active }) => $active ? 'auto' : 'none'};
  transition: opacity 0.3s;
  user-select: none;
  z-index: 9999;
`;
